export default __webpack_public_path__ + "static/media/manicureset.7fa7dadf.jpg";